import { useConstants } from "../../hooks/UseConstants";
import useSnackBar from "../../hooks/UseSnackBar";
import { useWaits } from "../../hooks/UseWait";
import CheckLogin from "../../services/CheckLogin";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, TextField } from "@mui/material";
import { useEffect } from "react";
import AuthPageLayout from "../../components/auth/AuthPageLayout";
import LoginSideImage from '../../images/login/login-side-admin.png';
import Fetch from "../../services/Fetch";
import { useLogin } from "../../hooks/UseLogin";
import { buildLoginFormData } from "../../helper/LoginFormData";
import SnackbarAlert from "../../components/SnackBar";

const loginInputSx = {
    width: '100%',
    '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.85)' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
    '& .MuiInput-underline:before': { borderBottomColor: 'rgba(255,255,255,0.5)' },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#fff' },
    '& .MuiInput-underline:after': { borderBottomColor: '#fff' },
    '& .MuiInputBase-input': { color: '#fff' },
};

function Login() {
    const navigate = useNavigate();
    const { host } = useConstants();
    const { email, setEmail, password, setPassword } = useLogin();
    const { getWait, setGetWait, sendWait, setSendWait } = useWaits();
    const { openSnackBar, type, message, setOpenSnackBar, setSnackBar } = useSnackBar();

    const checkLogin = async () => {
        try {
            const result = await CheckLogin(host);
            if (result?.data?.account_role === 'admin') {
                navigate('/dashboard', { replace: true });
                return;
            }
            if (result?.data?.account_role && result.data.account_role !== 'admin') {
                localStorage.removeItem('token');
            }
        } catch (err) {
            console.error(err);
            localStorage.removeItem('token');
        } finally {
            setGetWait(false);
        }
    };

    const login = async () => {
        setSendWait(true);

        const formData = buildLoginFormData({
            email: email,
            password: password,
        });

        let result = await Fetch(host + '/login', 'POST', formData);

        if (result.status === 200) {
            const role = result.data?.data?.user?.account_role;
            if (role !== 'admin') {
                setSnackBar('error', 'هذا الحساب ليس حساب مدير — استخدم لوحة المدرس أو الطالب');
                setSendWait(false);
                return;
            }
            localStorage.setItem('token', result.data.data.token);
            navigate('/dashboard');
        } else if (result.status === 422) {
            setSnackBar('error', result.data?.errors?.[0] || result.data?.message);
        } else if (result.status === 0) {
            setSnackBar('error', result.data?.message || 'تعذر الاتصال بالخادم');
        }

        setSendWait(false);
    };

    useEffect(() => {
        checkLogin();
    }, []);

    return (
        <>
            {getWait ? (
                <Box className="w-full h-screen relative flex justify-center items-center">
                    <CircularProgress size={70} />
                </Box>
            ) : (
                <AuthPageLayout
                    sideImage={LoginSideImage}
                    sideTitle="إدارة المنصة بكفاءة"
                    sideSubtitle="تحكم بالطلاب والمدرسين والدورات والعمليات المالية من لوحة إدارة متكاملة."
                    badge="لوحة الأدمن"
                    title="تسجيل الدخول"
                >
                    <TextField
                        onChange={(e) => setEmail(e.target.value)}
                        label="البريد الإلكتروني"
                        variant="standard"
                        sx={loginInputSx}
                        slotProps={{ htmlInput: { className: 'py-5' } }}
                    />
                    <TextField
                        onChange={(e) => setPassword(e.target.value)}
                        type="password"
                        label="كلمة المرور"
                        variant="standard"
                        sx={loginInputSx}
                    />
                    <button type="button" onClick={login} className="auth-btn-primary">
                        {sendWait ? <CircularProgress size={20} color="inherit" /> : 'دخول'}
                    </button>
                </AuthPageLayout>
            )}
            <SnackbarAlert open={openSnackBar} message={message} severity={type} onClose={() => setOpenSnackBar(false)} />
        </>
    );
}

export default Login;
